import React from 'react'
import { NormalText, TatterButton, Title } from './StyledComponent'
import { Box } from '@mui/system'
import { Modal, Paper } from '@mui/material'

export default function AlertDialog({
  open,
  setOpen,
  title,
  children,
  action,
  cancelAction,
}) {
  const handleClose = () => {
    if (cancelAction) {
      cancelAction()
    }
    setOpen(false)
  }
  const handleOk = async () => {
    if (action) {
      await action()
    }
    setOpen(false)
  }


  if (children) {
    return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Paper sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          height: 300,
          bgcolor: 'background.paper',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: "25px"
        }}>
          {/* <Box sx={{ display: "flex", flexDirection: "column" }}> */}
          <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#004B8D", borderRadius: "25px 25px 0px 0px" }}>
            <Title size={30} color={"#fff"}>{title ? title : "Alerta!!"}</Title>
          </Box>
          {
            children ?
              <Box sx={{ flex: 2, display: "flex", justifyContent: "center", alignItems: "center", padding: 2 }}>
                <NormalText color={"#68757E"} fontSize={20} id="alert-dialog-description">
                  {children}
                </NormalText>
              </Box>
              :
              <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
              </Box>
          }
          <Box sx={{ flex: 0.6, display: "flex", padding: 1, gap: 1 }}>
            <TatterButton flex={1} borderRadius={"25px 25px 25px 25px"} onClick={handleClose}>
              Cancelar
            </TatterButton>
            <TatterButton flex={1} borderRadius={"25px 25px 25px 25px"} onClick={handleOk}>
              OK
            </TatterButton>
          </Box>
          {/* </Box> */}
        </Paper>
      </Modal>
    )
  } else {
    return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Paper sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          height: 300,
          bgcolor: 'background.paper',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: "25px"
        }}>
          <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#004B8D", borderRadius: "25px 25px 0px 0px", }}>
            <Title color={"#fff"}>Alerta!!</Title>
          </Box>
          <Box sx={{ flex: 2, display: "flex", justifyContent: "center", alignItems: "center", padding: 1 }}>
            <NormalText color={"#68757E"} fontSize={20} id="alert-dialog-description">
              {title}
            </NormalText>
          </Box>
          <Box sx={{ flex: 0.6, display: "flex", padding: 1, gap: 1 }}>
            <TatterButton flex={1} borderRadius={"25px 25px 25px 25px"} onClick={handleClose}>
              Cancelar
            </TatterButton>
            <TatterButton flex={1} borderRadius={"25px 25px 25px 25px"} onClick={handleOk}>
              OK
            </TatterButton>
          </Box>
        </Paper>
      </Modal>
    )
  }

}
